var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRocket(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 107,
    height: 107,
    viewBox: "0 0 107 107",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M61.1112 80.876L61.1279 83.0672L45.3802 83.6195L45.3635 81.4283L61.1112 80.876Z",
    fill: "#FBFBFB",
    stroke: "#808080"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M51.6834 68.4555L51.7301 74.7729C51.7356 75.5214 52.3512 76.1115 53.0992 76.0852C53.8361 76.0593 54.4254 75.4443 54.4203 74.707L54.373 68.3619L63.3715 68.0457L61.3433 78.1762L45.0807 78.7463L42.8201 68.7661L51.6834 68.4555Z",
    fill: "#E0E0E0",
    stroke: "#808080"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40.7269 16.1774C43.5034 10.3518 47.5517 5.20033 52.6126 1.38263C57.7126 4.83845 61.8231 9.69379 64.6782 15.3112C56.7367 16.938 48.693 17.2316 40.7269 16.1774Z",
    fill: "#FAFAFA",
    stroke: "#808080"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M47.6139 33.5988C47.5935 30.7475 49.8997 28.3422 52.7497 28.2422C55.587 28.1428 57.9103 30.3692 57.9314 33.2091C57.9523 36.06 55.6462 38.4658 52.797 38.5656C49.9578 38.6649 47.6347 36.4387 47.6139 33.5988Z",
    fill: "white",
    stroke: "#808080"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3191 41.5589C34.4141 42.1711 34.5211 42.7837 34.646 43.394L34.6467 43.3974L39.6039 66.7262L29.4902 71.4926L31.5803 43.4409L34.3191 41.5589Z",
    fill: "white",
    stroke: "#808080"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M74.1005 41.9384L76.6019 69.8459L66.5502 65.7993L71.1562 42.1382L71.2571 41.6181L71.2474 41.6169C71.3219 41.1836 71.3883 40.7504 71.4485 40.3176L74.1005 41.9384Z",
    fill: "#E4E4E4",
    stroke: "#808080"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M39.6023 18.7543C43.9489 19.3729 48.3199 19.6087 52.6877 19.4552C57.0871 19.3011 61.4822 18.7494 65.8445 17.8153C68.9725 25.1536 70.0397 33.537 68.5143 41.6746L63.9097 65.3356L54.3535 65.6706L54.2242 47.953C54.2188 47.2045 53.6038 46.6151 52.8558 46.6413C52.1188 46.6673 51.5293 47.2821 51.5347 48.0196L51.6639 65.7655L42.2292 66.0965L37.2797 42.8049L37.2811 42.8048C35.6366 34.7752 36.5788 26.3161 39.6023 18.7543ZM52.7022 25.5523C48.3796 25.7038 44.894 29.3403 44.9255 33.6654C44.9572 38.0007 48.5112 41.4081 52.8447 41.2563C57.1664 41.1048 60.653 37.4674 60.6214 33.1432C60.5902 28.8076 57.0352 25.4002 52.7022 25.5523Z",
    fill: "#0056D2",
    stroke: "#808080"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M53.2885 85.9091L60.3912 85.6613L59.5368 93.7515L59.2165 91.2801L58.2295 91.2498L56.836 98.4729L56.3549 94.8341L55.3712 94.7935L53.4011 103.816L51.3087 94.9617L50.3249 95.0185L49.8922 98.72L48.3999 91.6203L47.4139 91.6667L47.1253 94.1835L46.1535 86.1596L53.2885 85.9091Z",
    fill: "#FFB20B"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M53.2885 85.9091L60.3912 85.6613L59.5368 93.7515L59.2165 91.2801L58.2295 91.2498L56.836 98.4729L56.3549 94.8341L55.3712 94.7935L53.4011 103.816L51.3087 94.9617L50.3249 95.0185L49.8922 98.72L48.3999 91.6203L47.4139 91.6667L47.1253 94.1835L46.1535 86.1596L53.2885 85.9091Z",
    fill: "url(#paint0_linear_71_33)",
    fillOpacity: 0.44
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M53.2885 85.9091L60.3912 85.6613L59.5368 93.7515L59.2165 91.2801L58.2295 91.2498L56.836 98.4729L56.3549 94.8341L55.3712 94.7935L53.4011 103.816L51.3087 94.9617L50.3249 95.0185L49.8922 98.72L48.3999 91.6203L47.4139 91.6667L47.1253 94.1835L46.1535 86.1596L53.2885 85.9091Z",
    stroke: "#808080"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_71_33",
    x1: 60.3487,
    y1: 84.5652,
    x2: 46.288,
    y2: 99.2342,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4530E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8E0808"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRocket);
export default __webpack_public_path__ + "static/media/rocket.c4104043844eca856172939afa2e601d.svg";
export { ForwardRef as ReactComponent };